import { FC } from "react"
import { useTranslation } from "react-i18next"

import NoValue from "components/NoValue/NoValue"
import { ErpInvoiceStatus } from "models/OutgoingInvoice"
import ErpValue from "./ErpValue"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import { ITooltipProps } from "components/Tooltip/Tooltip"

interface IErpOrderNumberProps {
    orderNumber?: string | null
    orderNumberStatus?: ErpInvoiceStatus
    orderNumberMessage?: string
    isInvoiceERPInterfaceConnected?: boolean
    longError?: boolean
    isItalic?: boolean
    isTempLmid?: boolean
}

const ErpOrderNumber: FC<IErpOrderNumberProps> = ({
    orderNumber,
    orderNumberStatus,
    orderNumberMessage,
    isInvoiceERPInterfaceConnected,
    longError,
    isItalic,
    isTempLmid,
}) => {
    const { t } = useTranslation()
    const notApplicable = <NoValue>
        <FlexibleContent text={t("common.notApplicable")} />
    </NoValue>

    const renderContent = (msg?: string) => (
        <>
            <p>{t("outgoingInvoices.orderNumberError")}</p>
            <br />
            <p>{msg}</p>
        </>
    );

    const warningTooltip: ITooltipProps = {
        content: renderContent(orderNumberMessage),
        maxWidth: "420px"
    }
    const errorTooltip: ITooltipProps = {
        content: renderContent(orderNumberMessage),
        maxWidth: "420px"
    }
    const tempLmidTooltip: ITooltipProps = {
        content: t('outgoingInvoices.tempLmidWarning'),
        maxWidth: "420px"
    }

    if (!!orderNumber) {
        if (orderNumberMessage) {
            return <ErpValue isInvalid text={orderNumber} tooltip={warningTooltip} />
        }
        return !!isTempLmid
            ? <ErpValue
                isInvalid
                isItalic={isItalic}
                text={orderNumber}
                tooltip={tempLmidTooltip}
            />
            : <>{orderNumber}</>
    }

    if (isInvoiceERPInterfaceConnected && !orderNumberStatus) {
        return notApplicable
    }

    switch (orderNumberStatus) {
        case ErpInvoiceStatus.pending:
            return <ErpValue
                isItalic={isItalic}
                text={t("common.pending")}
            />
        case ErpInvoiceStatus.error:
            return <ErpValue
                isInvalid
                isItalic={isItalic}
                text={longError ? t("outgoingInvoices.retrievingOrderNumberFailed") : t("common.failure")}
                tooltip={isTempLmid ? tempLmidTooltip : errorTooltip}
            />
        default:
            return notApplicable
    }
}

export default ErpOrderNumber
